module.exports = __webpack_public_path__ + "static/media/brand27.a5955416.png";